export enum PersonalDataRequestStatusEnum {
    created = 1,
    readByUser = 2,
    requestSubmitted = 3,
    archived = 4,
}
